import { TableCell, TableHead, TableRow, Typography } from "@mui/material";
import { isMobile } from "react-device-detect";
import { TableColumn, TableActions, TableStyles } from "./types";
import { tableHeaderCellStyles, tableActionHeaderCellStyles } from "./styles";

interface GenericTableHeaderProps {
  columns: TableColumn[];
  actions?: TableActions;
  styles?: TableStyles;
  actionsHeaderContent?: React.ReactNode;
  selectionHeaderContent?: React.ReactNode;
}

export function GenericTableHeader({
  columns,
  actions,
  styles,
  actionsHeaderContent,
  selectionHeaderContent,
}: GenericTableHeaderProps) {
  const hasActions = Boolean(actions);
  const hasSelection = selectionHeaderContent != null;

  return (
    <TableHead>
      <TableRow>
        {hasSelection && (
          <TableCell
            align="center"
            padding="checkbox"
            sx={{
              ...tableHeaderCellStyles,
              ...(styles?.header || {}),
            }}
          >
            {selectionHeaderContent}
          </TableCell>
        )}
        {isMobile && hasActions && (
          <TableCell
            align="center"
            sx={{
              ...tableActionHeaderCellStyles,
              ...(styles?.header || {}),
            }}
          >
            <Typography variant="subtitle2">
              {actionsHeaderContent ?? "Ações"}
            </Typography>
          </TableCell>
        )}
        {columns?.map((column, index) => (
          <TableCell
            key={`tableHeaderCell-${index}`}
            align={column.align || "center"}
            width={column.width}
            sx={{
              ...tableHeaderCellStyles,
              textAlign: column.align || "center",
              ...(styles?.header || {}),
            }}
          >
            <Typography variant="subtitle2">{column.column}</Typography>
          </TableCell>
        ))}
        {!isMobile && hasActions && (
          <TableCell
            align="center"
            sx={{
              ...tableActionHeaderCellStyles,
              ...(styles?.header || {}),
            }}
          >
            <Typography variant="subtitle2">
              {actionsHeaderContent ?? "Ações"}
            </Typography>
          </TableCell>
        )}
      </TableRow>
    </TableHead>
  );
}
